// extracted by mini-css-extract-plugin
export default {"paymentSection":"B8-z","disabled":"C8-z"};